var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89722 0.641486L9.89723 0.641499L17.4426 6.21097C17.6476 6.36235 17.6873 6.57744 17.6202 6.76263C17.552 6.95059 17.3713 7.1091 17.097 7.1091H16.1998H15.8498V7.4591V14.2918C15.8498 14.6459 15.7017 14.9895 15.4316 15.2458C15.161 15.5027 14.7901 15.65 14.3998 15.65H11.1499V10.8755C11.1499 10.3235 10.9187 9.79812 10.5136 9.41372C10.1092 9.02991 9.56438 8.81728 8.99991 8.81728C8.43544 8.81728 7.89065 9.02991 7.48622 9.41372C7.08116 9.79812 6.84995 10.3235 6.84995 10.8755V15.65H3.60002C3.20973 15.65 2.83887 15.5027 2.56818 15.2458C2.29812 14.9895 2.15006 14.6459 2.15006 14.2918V7.4591V7.1091H1.80006H0.902775C0.628066 7.1091 0.447679 6.95059 0.379727 6.76277C0.312696 6.57749 0.352532 6.36187 0.557408 6.20997C0.55748 6.20992 0.557552 6.20986 0.557623 6.20981L8.10257 0.641515L8.10261 0.641486C8.35715 0.453577 8.67287 0.35 8.99991 0.35C9.32695 0.35 9.64268 0.453577 9.89722 0.641486Z",
    stroke: "#333132",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d581f1ed1b872325f23b5ad1f19fcc97.svg";
export { ForwardRef as ReactComponent };